import { render } from "./ModuleOrMenu.vue?vue&type=template&id=76e46671&scoped=true"
import script from "./ModuleOrMenu.vue?vue&type=script&lang=js"
export * from "./ModuleOrMenu.vue?vue&type=script&lang=js"

import "./ModuleOrMenu.vue?vue&type=style&index=0&id=76e46671&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e46671"]])

export default __exports__